<template>
  <v-app>
    <v-main>
      <Home v-if="currentView === 'home'" />
      <ClientAccess v-else />
    </v-main>
  </v-app>
</template>

<script>
import Home from './components/Home.vue';
import ClientAccess from './components/ClientAccess.vue';

export default {
  name: 'App',

  components: {
    Home,
    ClientAccess,
  },

  data: () => ({
    currentView: 'home',
  }),
  created() {
    this.syncRoute();
    window.addEventListener('hashchange', this.syncRoute);
  },
  beforeDestroy() {
    window.removeEventListener('hashchange', this.syncRoute);
  },
  methods: {
    syncRoute() {
      this.currentView = window.location.hash.startsWith('#/client-access') ? 'client-access' : 'home';
    },
  },
};
</script>

<style lang="scss">
  :root {
    --bg-color: #F9F8F4;
    --text-color: #0B1521;
    --accent: #C5A065;
  }

  html,
  body {
    background: var(--bg-color);
    color: var(--text-color);
    font-family: 'Inter', sans-serif;
    font-weight: 300;
    overflow-x: hidden;
  }

  #app {
    color: var(--text-color)!important;
    background: var(--bg-color);
  }
  button,
  input {
    &:focus {
      outline: none!important;
    }
  }
  form {
    width: 100%;
  }
  .v-btn__content {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    color: var(--text-color)!important;
  }
  a {
    text-decoration: none;
  }

  button:focus-visible,
  a:focus-visible,
  input:focus-visible {
    outline: 2px solid rgba(197, 160, 101, 0.9);
    outline-offset: 2px;
  }
  //helpers
  .text-neutra-book {
    font-family: 'Inter', sans-serif;
    font-weight: 300;
  }
  .text-neutra-bold {
    font-family: 'Playfair Display', serif;
    font-weight: 700;
    letter-spacing: 0.01em;
  }
  .text-numeric {
    font-family: 'Space Grotesk', sans-serif;
    font-variant-numeric: tabular-nums;
  }
  .text--white {
    color: white;
  }
  .text-yellow {
    color: var(--accent);
  }
  .text-granate {
    color: var(--text-color)!important;
  }
  .pointer {
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .serene-light-blue-bg {
    background-color: transparent;
  }
  .serene-light-yellow-bg {
    background-color: transparent;
  }
  .serene-granate-bg {
    background-color: var(--text-color);
  }
  .relative {
    position: relative;
  }

  @media print {
    html, body, #app, .v-application {
      background: #fff !important;
      color: #000 !important;
    }

    .home__navbar,
    .home__menu-trigger,
    .home__drawer,
    .v-navigation-drawer,
    .v-navigation-drawer__scrim,
    .v-overlay,
    .v-btn,
    button {
      display: none !important;
    }

    .serene-light-blue-bg,
    .serene-light-yellow-bg,
    .serene-granate-bg {
      background: #fff !important;
      color: #000 !important;
    }

    p, span, a, h1, h2, h3, h4, h5, li, div {
      color: #000 !important;
      box-shadow: none !important;
      text-shadow: none !important;
    }

    body::after {
      content: "Serene Family Office - Confidential";
      position: fixed;
      left: 0;
      right: 0;
      bottom: 8mm;
      text-align: center;
      font-size: 10pt;
      color: #000;
    }
  }

  @font-face {
    font-family: 'NeutraText';
    src: url('~@/assets/fonts/neutraText-Bold.otf');
    font-display: swap;
  }
  @font-face {
    font-family: 'NeutraTextBook';
    src: url('~@/assets/fonts/neutraText-Book.otf');
    font-display: swap;
  }
</style>
